import { useState } from 'react';
import TodaysTimeline from './components/TodaysTimeline';
import WeeklyPerformance from './components/WeeklyPerformance';
import CreateNewTask from './components/CreateNewTask/CreateNewTask';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../hooks/usePermissions';
import { PermissionEnum } from '../../../enums/PermissionEnum';

const NewInspections = () => {
  const { t } = useTranslation(['inspector']);
  const { hasPermission } = usePermissions();

  const [refreshTaskSection, setRefreshTaskSection] = useState(0);

  const refreshTasks = () => {
    setRefreshTaskSection((prev) => prev + 1);
  };

  const isHasCreateTaskPermission = hasPermission([PermissionEnum.CREATE_INSPECTIONS]);

  return (
    <>
      {isHasCreateTaskPermission ? (
        <section className="md:text-md my-6 w-full text-sm">
          <CreateNewTask refreshTasks={refreshTasks} />
        </section>
      ) : null}
      <section className="my-6 grid w-full grid-cols-1 gap-10 lg:grid-cols-[2fr_1fr]">
        <div className="h-fit">
          <TodaysTimeline refreshTaskSection={refreshTaskSection} />
        </div>

        <div className="flex flex-col gap-6">
          <div className="h-fit">
            <WeeklyPerformance />
          </div>
        </div>
      </section>
    </>
  );
};

export default NewInspections;
